export default class Vector {
    // Public:
    constructor(values) {
        this.x = values[0];
        this.y = values[1];
    }

    computeModulus() {
        const x = this.x;
        const y = this.y;
        const x2 = Math.pow(x, 2);
        const y2 = Math.pow(y, 2);
        const mod = Math.sqrt(x2 + y2);
        return mod;
    }

    normalize() {
        const n = this.getNormalized();
        this.x = n.x;
        this.y = n.y;
    }

    getNormalized() {
        const mod = this.computeModulus();
        const x = this.x / mod;
        const y = this.y / mod;
        const n = {x: x, y: y};
        return n;
    }

    computeCrossProduct(b) {
        const a = this;
        return a.x * b.y - a.y * b.x;
    }

    computeDotProduct(b) {
        const a = this;
        return a.x * b.x + a.y * b.y;
    }
}
